import React from "react";
import { Facebook, Twitter, Youtube, Linkedin, Phone, Mail, MapPin } from "lucide-react";
import Logo from "./Logo";

const COLS = [
  {
    title: "Product",
    links: ["Features", "Dental Chart", "Appointments", "Billing", "WhatsApp Reminders", "Roadmap"],
  },
  {
    title: "For Doctors",
    links: ["Sign in", "Create account", "Why Dotmedy?", "Getting started", "Help center", "Video tutorials"],
  },
  {
    title: "Company",
    links: ["About", "Careers", "Blog", "Press kit", "Contact", "Partners"],
  },
  {
    title: "Legal",
    links: ["Privacy Policy", "Terms of Service", "Data Processing", "Refunds", "Security", "Compliance"],
  },
];

const Footer = () => (
  <footer className="bg-[#0F2A5F] text-white">
    <div className="max-w-[1280px] mx-auto px-6 py-16">
      <div className="grid grid-cols-1 lg:grid-cols-5 gap-10 mb-12">
        <div className="lg:col-span-2">
          <div className="mb-5 bg-white p-3 rounded-lg inline-block">
            <Logo size="md" />
          </div>
          <p className="text-white/70 text-sm leading-relaxed mb-6 max-w-sm">
            The Hi-Octane practice management platform crafted exclusively for
            dentists. Manage patients, chart teeth, schedule appointments and
            invoice — all in one place.
          </p>
          <ul className="space-y-2.5 text-sm text-white/80">
            <li className="flex items-center gap-2"><Phone size={14} className="text-[#14B8A6]" /> +91 99884 46478</li>
            <li className="flex items-center gap-2"><Mail size={14} className="text-[#14B8A6]" /> support@dotmedy.com</li>
            <li className="flex items-start gap-2"><MapPin size={14} className="text-[#14B8A6] mt-0.5 flex-shrink-0" /> <span>DotMedy.com<br/>69FF, Zirakpur, Mohali,<br/>Punjab, India</span></li>
          </ul>
        </div>

        {COLS.map((col) => (
          <div key={col.title}>
            <h5 className="text-sm font-bold uppercase tracking-wider text-white mb-4">{col.title}</h5>
            <ul className="space-y-2.5">
              {col.links.map((l) => (
                <li key={l}>
                  <a href="#" className="text-white/70 text-sm hover:text-[#14B8A6] transition-colors">{l}</a>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4">
        <p className="text-white/60 text-sm">
          © {new Date().getFullYear()} DotMedy.com — Hi-Octane Practice. All rights reserved.
        </p>
        <div className="flex items-center gap-2">
          {[Facebook, Twitter, Linkedin, Youtube].map((Icon, i) => (
            <a key={i} href="#" className="w-9 h-9 rounded-lg bg-white/10 hover:bg-[#14B8A6] flex items-center justify-center transition-colors" aria-label="social">
              <Icon size={15} className="text-white" />
            </a>
          ))}
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
